import { render, staticRenderFns } from "./PaymentMethodEdit.vue?vue&type=template&id=45e6d3f4&scoped=true&"
import script from "./PaymentMethodEdit.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e6d3f4",
  null
  
)

export default component.exports